import styled from 'styled-components';

import Field from 'components/Field';

export const StyledField = styled(Field)`
  margin-bottom: 16px;
`;

export const Header = styled.div`
  width: 100%;
  padding-top: 16px;
`;

export const Title = styled.h5`
  height: 32px;
  font-size: 24px;
  font-weight: 600;
  line-height: 1.33;
  letter-spacing: -0.24px;
  color: ${({ theme }) => theme.expense.values.title};
`;

export const CalendarIcon = styled.span`
  position: absolute;
  right: 16px;
  top: 0;
  bottom: 0;
  margin: auto;
  height: 20px;
  width: 20px;
  background-size: cover;
  background-image: url('/images/calendar.svg');
`;
